import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from 'devextreme-react/data-grid';
import PaginaToolbar from '../../components/PaginaToolbar';
import { criarConfiguracaoCndDs } from "../../DataSources";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroConfiguracaoCndGridState";

let _configuracaoCndCorrente = undefined;

export default class ConfiguracaoCndBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("tipocertidao/editar/" + e.data.id);
    }

    render() {

        const tiposNaturezaStr = [
            { id: "P", descricao: "Positiva" },
            { id: "N", descricao: "Negativa" },
        ]

        const tiposCadastroStr = [
            { id: "E", descricao: "Empresa" },
            { id: "I", descricao: "Imóvel" },
            { id: "C", descricao: "Contribuinte" },
        ]
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Configuração CND" novoCb={this.novaConfiguracaoCnd.bind(this)}>
                    <DataGrid
                        ref={grid => this._gridInstance = grid}
                        dataSource={criarConfiguracaoCndDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        columnAutoWidth={true}
                        columnHidingEnabled={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={window.innerWidth < 800}
                        filterSyncEnabled={true}
                        onEditingStart={this.onAtualizandoRow}>
                        <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                        <FilterRow visible={true} />
                        <Editing allowDeleting={true} allowUpdating={true} mode />
                        <Column dataField={'id'} caption={"#"} width={'50px'} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'naturezaStr'} caption={"Natureza da Certidão"}>
                            <Lookup
                                dataSource={tiposNaturezaStr}
                                valueExpr={"id"}
                                displayExpr={"descricao"}
                            />
                        </Column>
                        <Column dataField={'tipoCadastroStr'} caption={"Tipo da Certidão"}>
                            <Lookup
                                dataSource={tiposCadastroStr}
                                valueExpr={"id"}
                                displayExpr={"descricao"}
                            />
                        </Column>
                        <Column dataField={'validade'} caption={"Validade"} alignment={'left'}/>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    novaConfiguracaoCnd() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("tipocertidao/novo");
    }

}
